// src/lib/whitepapers.ts
//
// Catalogue centralisé des livres blancs disponibles au téléchargement.
// 1 seul endroit pour modifier le titre, l'URL du PDF, la couverture, etc.

import type { WhitepaperConfig } from '../components/whitepaper/WhitepaperModal';

/**
 * Livre blanc principal : chiffres clés du recrutement 2026.
 *
 * À uploader sur Supabase Storage (bucket `resources`) :
 *   - Le PDF lui-même → URL renseignée dans `pdfUrl`
 *   - La couverture (PNG/JPG, ratio 3:4) → URL renseignée dans `coverUrl`
 *     (optionnel : si absente, un mockup CSS fallback s'affiche)
 */
export const CHIFFRES_CLES_RECRUTEMENT: WhitepaperConfig = {
  slug: 'chiffres-cles-recrutement-2026',
  title: '12 chiffres qui changent le recrutement en 2026.',
  subtitle:
    "Le marché de l'emploi en clair pour les RH et les recruteurs : tensions, salaires, durée, no-show, coûts cachés. Sources officielles, lecture activable.",
  pdfUrl:
    'https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/resources/livre-blanc-chiffres-cles-recrutement-2026.pdf',
  // coverUrl laissé undefined → l'illustration SaaS inline (WhitepaperCoverIllustration)
  // s'affiche par défaut. Quand tu uploads une vraie couverture PNG/JPG sur Supabase
  // Storage, décommente et renseigne l'URL ici :
  // coverUrl: 'https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/resources/livre-blanc-chiffres-cles-recrutement-2026-cover.png',
  pageCount: 28,
  sources: 'INSEE · APEC · DARES · Talent Board',
};

/**
 * Livre blanc campagnes : attirer & onboarder les meilleurs talents sans budget.
 * Cible principale : DRH / dirigeants PME qui font du recrutement en panique
 * et qui n'ont pas envie de payer pour du sponsoring LinkedIn / Indeed.
 *
 * À uploader :
 *   - PDF → resources/livre-blanc-attirer-onboarder-talents-sans-budget.pdf
 *   - (optionnel) Couverture → resources/livre-blanc-attirer-onboarder-talents-cover.png
 */
export const ATTIRER_ONBOARDER_TALENTS: WhitepaperConfig = {
  slug: 'attirer-onboarder-talents-sans-budget',
  title: 'Comment attirer & onboarder les meilleurs talents.',
  subtitle:
    "Sans un euro de budget (ou presque). La méthode complète, étape par étape, clés en mains — appliquez-la à la lettre et transformez radicalement votre façon de recruter.",
  pdfUrl:
    'https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/resources/livre-blanc-attirer-onboarder-talents-sans-budget.pdf',
  // coverUrl: 'https://…/livre-blanc-attirer-onboarder-talents-cover.png',
  pageCount: 24,
  focalNumber: '0 €',
};
